<template>
  <v-app-bar
    class="print-hidden"
    app
    clipped-left
    flat
    outlined
    style="background-color: #fff8f5; padding: 0"
  >
    <v-app-bar-nav-icon
      @click="$emit('toggle-drawer')"
      v-if="!hideButton && device.isDesktop"
    ></v-app-bar-nav-icon>
    <app-logo />

    <v-toolbar-title
      style="font-weight: 500; font-size: 1.4rem"
      v-if="!['guest', 'admin_delivery'].includes(user.type)"
    >
      <span v-if="site?.name"> {{ toLatin(site?.name) }}</span>
      <span v-else-if="restaurantName">{{ toLatin(restaurantName) }}</span>
    </v-toolbar-title>

    <div class="menu-items-wrapper">
      <language-selector
        v-if="canSeeLanguage && device.isDesktop"
        component-type="dropdown"
        @setLang="$emit('set-lang', $event)"
      />

      <template v-if="!restaurant">
        <v-spacer></v-spacer>
        <div
          class="mr-4"
          v-if="user.companies && user.companies[0] && user.companies[0].is_credit"
        >
          <span style="font-size: 12px; font-weight: 500" v-if="user.credit?.length">
            {{ $t("credit_rest") }}:
            <span class="font-weight-black">
              {{ user.credit[user.credit.length - 1].duguje }}
            </span>
          </span>
        </div>
        <v-divider vertical class="mr-4"></v-divider>
        <v-btn
          v-if="user?.type == 'guest'"
          color="primary"
          :to="{ name: 'restorani-guest' }"
          class="mx-2"
        >
          {{ $t("restaurants") }}
        </v-btn>
        <template v-for="item in menu" v-if="device.isDesktop">
          <v-btn
            v-if="user.can_report"
            text
            :to="{ name: item.to.name }"
            class="mx-6 naruci_dugme"
            :key="item.title"
          >
            <span>{{ getMenuItemLabel(item) }}</span>
          </v-btn>
        </template>
        <language-selector
          v-if="availableLanguages.length > 1 && device.isDesktop"
          component-type="autocomplete"
          component-class="mr-2"
          @setLang="$emit('set-lang', $event)"
        />
        <app-avatar-menu />
      </template>
      <app-report-guest-avatar-menu v-if="user?.type === 'report_guest'" />

      <primary-button
        v-if="user.type != 'guest' && device.isDesktop"
        class="ml-2"
        @click="$emit('logout')"
        height="40px"
      >
        <v-icon>mdi-power</v-icon>
        <span v-if="device.isDesktop" class="ml-2">{{ $t("logout") }}</span>
      </primary-button>

      <sites-dropdown />
    </div>
    <v-app-bar-nav-icon
      @click="$emit('toggle-drawer')"
      v-if="!hideButton && !device.isDesktop"
    ></v-app-bar-nav-icon>
  </v-app-bar>
</template>

<script>
import { mapState } from "vuex";
import AppLogo from "@/components/layout/AppLogo.vue";
import LanguageSelector from "@/components/layout/LanguageSelector.vue";
import AppAvatarMenu from "@/components/layout/AppAvatarMenu.vue";
import AppReportGuestAvatarMenu from "@/components/layout/AppReportGuestAvatarMenu.vue";
import SitesDropdown from "@/components/layout/SitesDropdown.vue";

export default {
  name: "AppBar",
  components: {
    AppLogo,
    LanguageSelector,
    AppAvatarMenu,
    AppReportGuestAvatarMenu,
    SitesDropdown,
  },
  props: {
    showAppBar: {
      type: Boolean,
      default: false,
    },
    menu: {
      type: Array,
      required: true,
    },
    availableLanguages: {
      type: Array,
      default: () => [],
    },
    hideButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(["company", "restaurant"]),
    user() {
      return this.$store.state.user.user;
    },
    restaurantName() {
      return this.site?.name || this.company?.name || "";
    },
    site() {
      return this.$store.state.selectedRestaurant;
    },
    canSeeLanguage() {
      return ["admin", "restaurant", "admin_delivery"].includes(this.user?.type);
    },
  },
  methods: {
    getMenuItemLabel(item) {
      if (item.title === "Home") {
        return this.$t("order");
      }

      if (item.title === "Локација" || item.title === "Lokacija") {
        if (this.user.is_transferable == 1 || item.title === "Lokacija") {
          return this.translate(item.title);
        }
      }

      if (this.user.type === "recipient") {
        return this.translate(item.title);
      }
      return this.$t(item.title);
    },
  },
};
</script>

<style scoped>
/* Custom styles for app bar */
</style>
